import styled from "styled-components";
import {
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	TABLET_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
} from "@website-builder/utilities-index";

export const GeneralCheckmarksWrapper = styled.div`
	box-sizing: border-box;
	padding: 60px 0;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	h5 {
		font-size: 28px;
		line-height: 32.81px;
		font-weight: ${FONT_WT_MEDIUM};
		text-align: center;
		padding: 0;
		margin: 0 0 60px 0;
	}
	.container {
		display: flex;
		justify-content: center;
		align-items: flex-start;
		padding: 10px 0;
		margin: 0 auto;
		flex-direction: ${(props) =>
			props.imagePosition === "left" ? "row-reverse" : "row"};
	}
	.imageWrapper {
		margin: 0;
		img {
			width: 400px;
		}
	}
	.contentWrapper {
		.subHeader {
			text-align: left;
			font-size: 20px;
			font-weight: ${FONT_WT_MEDIUM};
			line-height: 28px;
		}

		img {
			margin-right: 25px;
			margin-top: 3px;
		}
		div {
			div {
				margin-bottom: 30px;
				line-height: 26px;
				:last-child {
					margin-bottom: 0px;
				}
			}
		}
		width: 435px;
		margin: ${(props) =>
			props.imagePosition === "right"
				? "auto 90px auto 0"
				: "auto 0 auto 90px"};
	}

	.tip {
		font-size: 16px;
		font-weight: ${FONT_WT_LIGHT};
		line-height: 27px;
		text-align: left;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		padding: 0px 0px 5px 0px;
	}

	.tip-heading {
		font-weight: ${FONT_WT_MEDIUM};
		padding: 0px 5px 0px 0px;
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 35px 30px;
		h5 {
			font-size: 26px;
			margin: 0 0 30px 0;
		}
		.container {
			flex-direction: column;
			.contentWrapper {
				width: 100%;
			}
			.imageWrapper {
				width: 100%;
			}
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) and (min-width: ${TABLET_BP}px) {
		.container {
			flex-wrap: wrap;
			.contentWrapper {
				width: 100%;
				margin: 0 auto 80px 0;
			}
		}
		.imageWrapper {
			text-align: center;
		}
	}

	@media only screen and (max-width: ${TABLET_BP - 1}px) {
		padding: 35px 20px;
		.contentWrapper {
			margin: 0 auto 80px 0;
		}
		.imageWrapper {
			.imageContainer {
				img {
					width: 100%;
				}
			}
		}
	}
`;

export const Description = styled.div`
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	line-height: 26px;
	text-align: center;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	max-width: 870px;
	margin: -32px auto 50px;

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		margin: 0 auto 0px;
	}
`;
